import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=66a3a622"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./OrderDetail.vue?vue&type=style&index=0&id=66a3a622&prod&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports